import { render, staticRenderFns } from "./PreferredProductPriceFields.vue?vue&type=template&id=c8220428&scoped=true"
import script from "./PreferredProductPriceFields.vue?vue&type=script&lang=js"
export * from "./PreferredProductPriceFields.vue?vue&type=script&lang=js"
import style0 from "./PreferredProductPriceFields.styles.scss?vue&type=style&index=0&id=c8220428&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8220428",
  null
  
)

export default component.exports